module.exports = __webpack_public_path__ + "static/media/1.98e1d265.JPG";